<div class="tooltiptext" apply="theme" [attr.direction]="direction" #cardContent>
  <div class="card margin-all-0 hoverable">
    <div class="card-action" tag-style="theme" apply="theme">
      <p class="margin-all-0 fnt-13-i">{{title}}</p>
    </div>
    <div class="card-content">
      <span class="pretty-scrollbar fnt-13-i">
        <p [innerHTML]="text | sanitizeHtml"></p>
      </span>
    </div>
  </div>
</div>